 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name                 : 'ClientsMergeDuplicates',
		confirm_before_submit: true,
		confirm_message      : "<em>WARNING: THIS ACTION CANNOT BE UNDONE</em><br><br>If you are not sure the clients you are merging are the same person, then you should NOT continue with this merge.<br><br>The merge will take any of the other profiles listed under the client name and merge them with the profile selected in the <strong>\"Correct\"</strong> column.<br><br>Are you sure you wish to merge all of the profile data related to selected clients?<br><br>Click <strong>\"Yes\"</strong> to continue with the merge or <strong>\"No\"</strong> to abort this action.",
	};

	$(document).ready(function documentReady() {
		Adzuki.onload('Clients/manageDuplicates', function onload() {
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function load()
	{
		$("button.not-a-duplicate").on('click', function removeClientFromDupeManager() {
			var $form       = $(this).parents('form'),
			    $inputs     = $form.find('input, button'),
			    client_name = $form.find('.client-name').text(),
			    client_ids  = [];

			$.each($form.serializeArray(), function getClientIds(i, input) {
				if (input.name.indexOf('all_client_ids') !== -1) {
					client_ids.push(input.value);
				}
		});

			Adzuki.CustomConfirm({
				body   : 'This will remove <strong>' + client_name + '</strong> from the Duplicate Profile Manager. This WILL NOT remove the client profile from your CP Maxx client database. This CANNOT be undone. Do you wish to proceed?',
				confirm: function removeClients() {
					$inputs.prop('disabled', true);

					Adzuki.Ajax.post('/Clients/removeDuplicates', {client_ids: client_ids})
					.then(function removeDupeClient(response) {
						if (response.status) {
							$form.fadeOut('normal', function _removeDupe() {
								$(this).remove();
								Adzuki.StatusMessage('success', client_name + ' has been removed from the Duplicate Profile Manager');
							});
						}
						else {
							Adzuki.StatusMessage('error', response.message);
							$inputs.prop('disabled', false);
						}
					});
				}
			});
		});

		$('input[name="form_component_data[ClientsMergeDuplicates][correct_client_id]"]').on('change', function toggleInputState() {
			var $self = $(this);

			// enable all inputs for this group
			$self.parents('ul').find('input[disabled]').prop('disabled', false);

			// disable the 'ignore' checkbox for this row
			$self.parents('p').next('p').find('input').prop('checked', false).prop('disabled', true);
		});
	};

}(jQuery, window.Adzuki || {}));
